import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OauthService } from '@terradotta/commons';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  
  title = 'app';
  @ViewChild('pagebody') pagebody: ElementRef;
  containerWidth: number;
  queryParams: any;

  constructor(private route: ActivatedRoute,
    private _oauthService: OauthService) { }

  ngOnInit(){
    var that = this;

    that._oauthService.getToken().then(resp => {
      that.route.queryParams.subscribe(data => {
        that.queryParams = data;

        var width = window.innerWidth;
        var cellSize = Math.round(width / 18);
        that.containerWidth = cellSize * 12;
      });
    });
  }
}
